import { useIntl } from "react-intl";
import { useQuery } from "react-query";

import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  BaseFilter,
  ListRequestOfBaseFilter,
  ListResponseOfProductYear,
  ProductYear,
} from "services/KnowfullyAdminClient";

type SelectProductYearProps = Omit<
  AutocompleteWithQueryProps<ProductYear>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectProductYear = ({ ...rest }: SelectProductYearProps) => {
  const { formatMessage: t } = useIntl();
  const { productService } = useGlobalContext();

  const fetchedProductYears = useQuery<ListResponseOfProductYear>(
    ["productYears"],
    () =>
      productService.getProductYears(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
          sortDescending: true,
          parameters: BaseFilter.fromJS({}),
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="name"
      fetchedData={fetchedProductYears}
      failMessage={t({ id: "selectProductYearFetchFailed" })}
    />
  );
};

export default SelectProductYear;
